<template>
  <information-page id="information-page" :title="t.title">
    <template v-slot:navbar>
      <div
        class="navbar-information flex items-stretch text-chplus-regular px-8"
      >
        <div
          class="flex-1 text-center border-b-2 lg:border-b-2px border-nav-light font-bold"
        >
          <div>{{ $t("views.information.title") }}</div>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <template v-for="(part, index) in t.content">
        <p v-if="typeof part === 'string'" :key="index.toString()">
          {{ part }}
        </p>
        <ul v-else-if="Array.isArray(part)" :key="index.toString() + 'list'">
          <li v-for="(element, index) in part" :key="index">{{ element }}</li>
        </ul>
        <div
          v-else-if="part.type === 'header'"
          :key="index.toString() + 'header'"
          class="font-bold"
        >
          {{ part.value }}
        </div>
      </template>
      <hr />
      <a
        :href="t.button.link"
        target="_blank"
        class="rounded-lg p-3 bg-interaction-dark text-white"
      >
        {{ t.button.label }}
        <icon-link-profile />
      </a>
    </template>
  </information-page>
</template>

<script>
import InformationPage from "@/components/layouts/InformationPage";
import IconLinkProfile from "@/components/icons/IconLinkProfile";

export default {
  name: "Informative",
  components: {
    InformationPage,
    IconLinkProfile
  },
  computed: {
    t() {
      const translations = this.$t("views.information");
      if (
        !(this.resource in translations) ||
        !(this.level in translations[this.resource])
      ) {
        return {
          title: "",
          content: []
        };
      }
      return translations[this.resource][this.level];
    }
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    level: {
      String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.navbar-information {
  box-sizing: border-box;
  padding: 0 2.25rem;
  height: 100%;
  line-height: 1.25em;

  a {
    line-height: 1em;
    vertical-align: baseline;
  }
}

@media screen and (min-width: 768px) {
  .navbar-information {
    padding: 0 3.7rem;
  }
}
</style>
